import { createStyles, keyframes } from 'antd-style'

const showHelpIn = keyframes('showHelpIn', {
  '0%': {
    transform: 'translateY(-5px)',
    opacity: 0
  },
  to: {
    transform: ' translateY(0)',
    opacity: 1
  }
})

export const useFormItemStyles = createStyles(
  ({ css, prefixCls, token }, { componentCls }: { componentCls: string }) => {
    const status = (color: string, bgColor: string) => ({
      [`
      .${prefixCls}-cascader-picker,
      .${prefixCls}-picker,
      .${prefixCls}-input-number,
      .${prefixCls}-input,
      .${prefixCls}-input-affix-wrapper
      `]: {
        borderColor: `${color}`,
        borderInlineEndWidth: '1px',
        outline: 0
      },
      [`.${prefixCls}-select-selector`]: {
        borderColor: `${color} !important`
      }
    })

    return css({
      [`&.${componentCls}`]: {
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridTemplateRows: 'auto 1fr',
        gridTemplateAreas: `
          'a b'
          'c d'
          'e f'
        `,
        alignItems: 'flex-start',
        [`&-layout-vertical`]: {
          gridTemplateColumns: 'auto',
          gridTemplateRows: 'auto auto 1fr',
          gridTemplateAreas: `
          'a'
          'b'
          'd'
          'f'
        `
        },
        [`&-feedbackLayout-default`]: {
          marginBottom: token.marginLG
        },
        [`&.${componentCls}-success`]: status(
          token.colorSuccess,
          token.colorSuccessBg
        ),
        [`&.${componentCls}-error`]: status(
          token.colorError,
          token.colorErrorBg
        )
      },
      [`.${componentCls}-label`]: {
        display: 'flex',
        alignItems: 'center',
        height: 32
      },
      [`.${componentCls}-label-content`]: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: token.paddingXXS / 2,
        marginInlineEnd: token.marginXS,
        color: token.colorTextHeading,
        whiteSpace: 'nowrap',
        [`&-overflow`]: {
          overflow: 'hidden'
        },
        [`&-wrap`]: {
          whiteSpace: 'normal'
        },
        [`&-align-left`]: {
          justifyContent: 'flex-start'
        },
        [`&-align-right`]: {
          justifyContent: 'flex-end'
        }
      },
      [`.${componentCls}-asterisk`]: {
        display: 'inline-block',
        color: token.colorError,
        fontFamily: 'SimSun, sans-serif'
      },
      [`.${componentCls}-label-text`]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      [`.${componentCls}-colon`]: {
        marginBlockStart: -2
      },
      [`.${componentCls}-control`]: {
        gridArea: 'b',
        minHeight: 32,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        [`
        .${prefixCls}-select,
        .${prefixCls}-input-number,
        .${prefixCls}-picker
        `]: {
          width: '100%'
        },
        [`&-fullness>*:first-child`]: {
          flex: '0 0 100%'
        }
      },
      [`.${componentCls}-tip`]: {
        gridArea: 'f',
        position: 'relative'
      },
      [`.${componentCls}-help`]: {
        gridArea: 'd',
        position: 'relative'
      },
      [`.${componentCls}-feedback`]: {
        position: 'absolute',
        top: 2,
        left: 0,
        width: '100%',
        fontSize: token.fontSizeSM,
        color: token.colorTextSecondary,
        '&-appear, &-enter': {
          animationDuration: '0.3s',
          animationFillMode: 'both',
          animationPlayState: 'paused',
          opacity: 0,
          animationTimingFunction: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
          '&-active': {
            animationPlayState: 'running',
            animationName: showHelpIn
          }
        },
        [`&-error`]: {
          color: token.colorError
        },
        [`&-success`]: {
          color: token.colorSuccess
        }
      }
    })
  },
  { hashPriority: 'low' }
)
